var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.config)?_c('config-add-edit',{attrs:{"mode":"Edit","buttonText":"Save"},on:{"change":function($event){return _vm.handleChange()}},model:{value:(_vm.config),callback:function ($$v) {_vm.config=$$v},expression:"config"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }